import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FontawesomeService } from '../../../services/fontawesome.service';
import { collapse } from '../../../../assets/animations/animations';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { TranslocoPipe } from '@jsverse/transloco';
import { InputOtpChangeEvent, InputOtpModule } from 'primeng/inputotp';

@Component({
  selector: 'app-tfa-input',
  templateUrl: './tfa-input.component.html',
  styleUrls: ['./tfa-input.component.scss'],
  animations: [collapse],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, FaIconComponent, TranslocoPipe, InputOtpModule],
})
export class TfaInputComponent {
  @Input() autoSubmit: boolean = false;
  @Output() submit: EventEmitter<string> = new EventEmitter<string>();
  public tfaValue: string = '';
  public validated: boolean = false;
  valid: boolean = false;

  constructor(
    public fontawesomeService: FontawesomeService,
    private cdr: ChangeDetectorRef,
    private host: ElementRef<HTMLElement>,
  ) {}

  public reset() {
    this.validated = false;
    this.valid = false;
    this.tfaValue = '';
    this.cdr.markForCheck();
  }

  public focus() {
    const focusFirstInput = () => {
      const firstInput = this.host.nativeElement.querySelector<HTMLInputElement>('.p-inputotp-input');
      firstInput?.focus();
    };

    focusFirstInput();
    // p-inputOtp may not have rendered its inputs yet when the step just switched
    if (!this.host.nativeElement.querySelector('.p-inputotp-input')) {
      setTimeout(focusFirstInput);
    }
    this.cdr.markForCheck();
  }

  public validate(valid: boolean): void {
    this.validated = true;
    this.valid = valid;
    if (!valid) {
      this.tfaValue = '';
      this.focus();
    }
    this.cdr.markForCheck();
  }

  public onOtpChange(event: InputOtpChangeEvent): void {
    this.tfaValue = event?.value?.toString?.() ?? String(event?.value ?? '');

    if (this.autoSubmit && this.tfaValue.length === 6) {
      this.submit.emit(this.tfaValue);
    }

    this.cdr.markForCheck();
  }

  public get invalid(): boolean {
    return this.filled && !this.valid;
  }

  public get filled(): boolean {
    return this.tfaValue?.toString().length === 6;
  }
}
